var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchDocument(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 182,
    viewBox: "0 0 229 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.2194 40.502L56.7222 138.61C56.0763 141.86 58.1875 145.019 61.4377 145.664L131.745 159.637C134.995 160.283 138.153 158.171 138.799 154.921L158.296 56.8132C158.942 53.563 156.831 50.4047 153.581 49.7588L83.2738 35.7866C80.0236 35.1407 76.8653 37.2518 76.2194 40.502Z",
    fill: "#DDE4EE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1494 57.1971C23.9108 57.1971 26.1494 54.9586 26.1494 52.1971C26.1494 49.4357 23.9108 47.1971 21.1494 47.1971C18.388 47.1971 16.1494 49.4357 16.1494 52.1971C16.1494 54.9586 18.388 57.1971 21.1494 57.1971Z",
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0444 7.19714C72.6433 7.19714 73.9395 5.901 73.9395 4.30212C73.9395 2.70325 72.6433 1.4071 71.0444 1.4071C69.4456 1.4071 68.1494 2.70325 68.1494 4.30212C68.1494 5.901 69.4456 7.19714 71.0444 7.19714Z",
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M224.823 129.197C226.422 129.197 227.718 127.901 227.718 126.302C227.718 124.703 226.422 123.407 224.823 123.407C223.224 123.407 221.928 124.703 221.928 126.302C221.928 127.901 223.224 129.197 224.823 129.197Z",
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.86133 85.8671V91.8671",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92383 89.1171H1.92383",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.111 27.6171V33.6171",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M213.174 30.8671H207.174",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M150.877 11.2299V17.2299",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M153.939 14.4799H147.939",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5179 55.9093L111.521 59.9983",
    stroke: "#C5CDD8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4034 135.112L102.331 139.795",
    stroke: "#C5CDD8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4756 120.063L123.781 129.246",
    stroke: "#C5CDD8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1998 104.546L102.367 108.597",
    stroke: "#C5CDD8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2927 87.8998L112.883 93.3096",
    stroke: "#C5CDD8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M87.9998 72.0308L134.778 81.331",
    stroke: "#C5CDD8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M160.375 65.3645C156.765 61.6098 152.441 58.615 147.656 56.5565C142.871 54.498 137.723 53.4174 132.514 53.3781C127.306 53.3389 122.142 54.3419 117.327 56.3281C112.512 58.3143 108.142 61.2436 104.476 64.9436C89.694 79.8461 89.4434 104.111 103.902 119.329C110.255 126.015 118.768 130.237 127.934 131.248C137.101 132.259 146.33 129.994 153.986 124.854L182.218 154.223C182.567 154.586 183.047 154.796 183.551 154.806C184.055 154.816 184.543 154.625 184.906 154.275L191.942 147.511C192.305 147.161 192.515 146.682 192.525 146.177C192.534 145.673 192.344 145.186 191.994 144.822L163.76 115.456C169.173 108.04 171.801 98.9547 171.182 89.7944C170.563 80.6342 166.737 71.9847 160.375 65.3645ZM151.581 112.56C147.598 116.389 142.569 118.951 137.13 119.922C131.691 120.893 126.086 120.229 121.024 118.015C115.962 115.8 111.671 112.135 108.692 107.481C105.713 102.828 104.181 97.3958 104.29 91.8718C104.399 86.3477 106.143 80.98 109.302 76.4472C112.461 71.9145 116.894 68.4203 122.039 66.4066C127.184 64.3929 132.811 63.9501 138.207 65.1342C143.604 66.3183 148.528 69.076 152.358 73.0588C154.901 75.7034 156.898 78.823 158.235 82.2394C159.572 85.6558 160.223 89.3021 160.151 92.9701C160.079 96.6382 159.285 100.256 157.814 103.617C156.344 106.978 154.226 110.017 151.581 112.56Z",
    fill: "#8792A8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M111.529 84.6664C108.387 84.6664 108.382 89.5496 111.529 89.5496C114.676 89.5496 114.676 84.6664 111.529 84.6664Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M133.429 69.0274C124.973 68.837 117.278 73.0787 113.187 79.4827C111.852 81.5722 115.642 83.4187 116.97 81.3392C120.358 76.0377 126.794 72.6703 133.757 72.8457C141.053 73.0286 147.692 77.2027 151.207 82.9953C152.54 85.1926 156.035 83.1957 154.715 81.011C150.433 73.9757 142.165 69.2153 133.429 69.0274Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M126.125 181.489C170.308 181.489 206.125 179.803 206.125 177.723C206.125 175.643 170.308 173.957 126.125 173.957C81.9422 173.957 46.125 175.643 46.125 177.723C46.125 179.803 81.9422 181.489 126.125 181.489Z",
    fill: "url(#paint0_radial)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(126.125 177.723) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchDocument);
export default __webpack_public_path__ + "static/media/search_document.4e0e651054473aaed94c1afa5374f4c0.svg";
export { ForwardRef as ReactComponent };